'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$24() {
  this.bgX = null;
  this.bgV = null;
  this.bgW = false;
  this.bgT = null;
  this.bgU = false;
  this.bgY = false;
  this.bgZ = false;
  this.bgX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$24 as $c_Lpresto_PrestoRouter$$anon$24 };
$p = $c_Lpresto_PrestoRouter$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$24;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$24() {
}
export { $h_Lpresto_PrestoRouter$$anon$24 as $h_Lpresto_PrestoRouter$$anon$24 };
$h_Lpresto_PrestoRouter$$anon$24.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bgX;
});
$p.t = (function() {
  if ((!this.bgW)) {
    this.bgV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgW = true;
  }
  return this.bgV;
});
$p.ag = (function() {
  if ((!this.bgU)) {
    this.bgT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgU = true;
  }
  return this.bgT;
});
$p.v = (function() {
  if ((!this.bgZ)) {
    this.bgY = false;
    this.bgZ = true;
  }
  return this.bgY;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$24, "presto.PrestoRouter$$anon$24", ({
  NX: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$24 as $d_Lpresto_PrestoRouter$$anon$24 };
//# sourceMappingURL=presto.-Presto-Router$$anon$24.js.map
